<input (change)="onChange()" type="radio" name="icon" [attr.data-cy]="'register-company-size-' + caption" id="{{ caption }}" />
<label for="{{ caption }}">
	<div [ngClass]="{ 'cn-toggle-option--selected': selectionState }" class="cn-toggle-option pt-3">
		<div class="cn-toggle-option_icon">
			<img class="invert-color" [src]="source" alt="preview" />
		</div>
		<div class="pt-1">{{ caption }}</div>
	</div>
</label>
